import React from 'react'

const CartModalContext = React.createContext<{
  closeModal?: () => void | undefined
}>({})

export default CartModalContext
